import { render, staticRenderFns } from "./ShopDonation.vue?vue&type=template&id=c1910980&"
import script from "./ShopDonation.vue?vue&type=script&lang=js&"
export * from "./ShopDonation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports